import { type FC, useRef } from "react";

import "rapidoc";

export const DocsPage: FC = () => {
  const rdRef = useRef<any>(null);

  return (
    <div className="flex h-svh flex-col">
      <rapi-doc
        ref={rdRef}
        spec-url="/api/v1/openapi.json"
        default-api-server="%s"
        theme="dark"
        render-style="read"
        show-header="false"
        allow-try="true"
        persist-auth="true"
        schema-style="tree"
        allow-advanced-search="true"
        schema-description-expanded="true"
        allow-schema-description-expand-toggle="false"
        allow-spec-file-download="true"
        allow-spec-file-load="false"
        allow-spec-url-load="false"
        fetch-credentials="include"
        show-curl-before-try="true"
      />
    </div>
  );
};
